<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="ipPools"
      :items="ipPools"
      :fields="ipPoolsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedIpPools"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      ipPoolsFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'address', label: this.$i18n.t('Address'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedIpPools: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedIpPools = {
        id: 0,
        name: '',
        address: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditIpPools', '#btnShow')
    },
    editItem (item) {
      this.selectedIpPools = item
      this.$root.$emit('bv::show::modal', 'modalEditIpPools', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "IP pools"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_IP_POOLS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_IP_POOLS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    ipPools () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/IP_POOLS']))
      for (let el of copy) {
        el.address = el.ip + '/' + el.mask_dec
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_IP_POOLS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/ipPools/main.vue